export default __webpack_public_path__ + "static/media/trophy.5f29b355.png";